// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"208":"0a38f93f","478":"6f074d1f","563":"27aae66e","662":"1678903f","816":"5fde6533"}[chunkId] + ".chunk.css";
};